var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "7"
              }
            },
            [
              _c(
                "v-form",
                {
                  attrs: {
                    autocomplete: "off"
                  },
                  on: {
                    submit: function submit($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-card",
                            [
                              _c("gg-card-header", [
                                _vm._v(" Domain Information ")
                              ]),
                              _c(
                                "gg-card-text",
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mt-3 px-6"
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0 px-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  _vm.rules[
                                                    _vm.domainFieldName
                                                  ],
                                                expression:
                                                  "rules[domainFieldName]"
                                              }
                                            ],
                                            key: _vm.domainFieldName,
                                            attrs: {
                                              outlined: "",
                                              label: "Domain",
                                              "data-vv-name":
                                                _vm.domainFieldName,
                                              "data-vv-as": "Domain",
                                              "error-messages": _vm.errors.collect(
                                                _vm.domainFieldName
                                              ),
                                              autocomplete: _vm.domainFieldName
                                            },
                                            model: {
                                              value: _vm.model.domain,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "domain",
                                                  $$v
                                                )
                                              },
                                              expression: "model.domain"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0 px-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  _vm.rules[
                                                    _vm.usernameFieldName
                                                  ],
                                                expression:
                                                  "rules[usernameFieldName]"
                                              }
                                            ],
                                            key: _vm.usernameFieldName,
                                            ref: "username",
                                            attrs: {
                                              outlined: "",
                                              label: "Username",
                                              "data-vv-name":
                                                _vm.usernameFieldName,
                                              "data-vv-as": "Username",
                                              "error-messages": _vm.errors.collect(
                                                _vm.usernameFieldName
                                              ),
                                              autocomplete:
                                                _vm.usernameFieldName
                                            },
                                            on: {
                                              focus: _vm.createUsernameByDomain
                                            },
                                            model: {
                                              value: _vm.model.username,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "username",
                                                  $$v
                                                )
                                              },
                                              expression: "model.username"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("input", {
                                        staticClass: "hidden",
                                        attrs: {
                                          type: "text",
                                          value: "value",
                                          name: "username"
                                        }
                                      }),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.model.password,
                                            expression: "model.password"
                                          }
                                        ],
                                        ref: "password",
                                        staticClass: "hidden",
                                        attrs: {
                                          type: "password",
                                          "data-vv-name": "passwords",
                                          autocomplete: "new-password"
                                        },
                                        domProps: {
                                          value: _vm.model.password
                                        },
                                        on: {
                                          input: function input($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.model,
                                              "password",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0 px-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("compact-password", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  _vm.rules[
                                                    _vm.passwordFieldName
                                                  ],
                                                expression:
                                                  "rules[passwordFieldName]"
                                              }
                                            ],
                                            key: _vm.passwordFieldName,
                                            attrs: {
                                              outlined: "",
                                              label: "Password",
                                              "data-vv-name":
                                                _vm.passwordFieldName,
                                              "data-vv-as": "Password",
                                              "error-messages": _vm.errors.collect(
                                                _vm.passwordFieldName
                                              ),
                                              "with-generator": "",
                                              "cpanel-app": "createacct",
                                              autocomplete:
                                                _vm.passwordFieldName
                                            },
                                            model: {
                                              value: _vm.model.password,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "model.password"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0 px-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  _vm.rules.confirmPassword,
                                                expression:
                                                  "rules.confirmPassword"
                                              }
                                            ],
                                            attrs: {
                                              outlined: "",
                                              type: "password",
                                              label: "Confirm Password",
                                              "data-vv-name": "confirmPassword",
                                              "data-vv-as": "Confirm Password",
                                              "error-messages": _vm.errors.collect(
                                                "confirmPassword"
                                              ),
                                              autocomplete: "new-password"
                                            },
                                            model: {
                                              value: _vm.model.confirmPassword,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "confirmPassword",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.confirmPassword"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0 px-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  _vm.rules[_vm.emailFieldName],
                                                expression:
                                                  "rules[emailFieldName]"
                                              }
                                            ],
                                            key: _vm.emailFieldName,
                                            attrs: {
                                              outlined: "",
                                              label: "Email",
                                              "data-vv-name":
                                                _vm.emailFieldName,
                                              "data-vv-as": "Email",
                                              "error-messages": _vm.errors.collect(
                                                _vm.emailFieldName
                                              ),
                                              autocomplete: _vm.emailFieldName
                                            },
                                            model: {
                                              value: _vm.model.contactemail,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "contactemail",
                                                  $$v
                                                )
                                              },
                                              expression: "model.contactemail"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-card",
                            [
                              _c(
                                "gg-card-header",
                                {
                                  attrs: {
                                    divider: _vm.packageInfoExpanded
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex justify-between"
                                    },
                                    [
                                      _c("div", [_vm._v(" Package ")]),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                icon: ""
                                              },
                                              on: {
                                                click: function click($event) {
                                                  _vm.packageInfoExpanded = !_vm.packageInfoExpanded
                                                }
                                              }
                                            },
                                            [
                                              _vm.packageInfoExpanded
                                                ? _c("v-icon", [
                                                    _vm._v("mdi-chevron-down")
                                                  ])
                                                : _c("v-icon", [
                                                    _vm._v("mdi-chevron-right")
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm.packageInfoExpanded
                                ? _c(
                                    "gg-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "mt-3 px-6"
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0 px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c("gg-select", {
                                                key: "package",
                                                attrs: {
                                                  id: "package",
                                                  name: "package",
                                                  dense: "",
                                                  outlined: "",
                                                  label: "Choose a Package",
                                                  items: _vm.packagesOptions,
                                                  "item-value": "name",
                                                  "item-text": "name"
                                                },
                                                on: {
                                                  change:
                                                    _vm.initManualResourceFormData
                                                },
                                                model: {
                                                  value: _vm.model.msel,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "msel",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.msel"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0 px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                staticStyle: {
                                                  margin: "0",
                                                  padding: "0"
                                                },
                                                attrs: {
                                                  label:
                                                    "Select Options Manually"
                                                },
                                                model: {
                                                  value: _vm.model.manual,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "manual",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.manual"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm.canShowPackageManuallySection &&
                                          _vm.model.manual
                                            ? _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("v-checkbox", {
                                                    staticStyle: {
                                                      margin: "0",
                                                      padding: "0"
                                                    },
                                                    attrs: {
                                                      label:
                                                        "Save Manual Settings as a Package"
                                                    },
                                                    model: {
                                                      value: _vm.model.savepkg,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "savepkg",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.savepkg"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.isCreatingNewPackage
                                            ? _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          _vm.rules.packageName,
                                                        expression:
                                                          "rules.packageName"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label: "Package Name",
                                                      "data-vv-name":
                                                        "packageName",
                                                      "data-vv-as":
                                                        "packageName",
                                                      "error-messages": _vm.errors.collect(
                                                        "packageName"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.pkgname,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "pkgname",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.pkgname"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.isCreatingNewPackage
                                            ? _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-select", {
                                                    attrs: {
                                                      outlined: "",
                                                      label: "Feature List",
                                                      items:
                                                        _vm.featureListsOptions
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.model.featurelist,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "featurelist",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.featurelist"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.model.manual
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "gg-card",
                                [
                                  _c(
                                    "gg-card-header",
                                    {
                                      attrs: {
                                        divider: _vm.manualResourcesExpanded
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex justify-between"
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(" Manual Resource Options ")
                                          ]),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "gg-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    icon: ""
                                                  },
                                                  on: {
                                                    click: function click(
                                                      $event
                                                    ) {
                                                      _vm.manualResourcesExpanded = !_vm.manualResourcesExpanded
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.manualResourcesExpanded
                                                    ? _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-chevron-down"
                                                        )
                                                      ])
                                                    : _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-chevron-right"
                                                        )
                                                      ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm.manualResourcesExpanded
                                    ? _c(
                                        "gg-card-text",
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mt-3 px-6"
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: _vm.rules.quota,
                                                        expression:
                                                          "rules.quota"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label:
                                                        "Disk Space Quota (MB)",
                                                      "data-vv-name": "quota",
                                                      "data-vv-as":
                                                        "Disk Space Quota",
                                                      "error-messages": _vm.errors.collect(
                                                        "quota"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.quota,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "quota",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "model.quota"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          _vm.rules.bwlimit,
                                                        expression:
                                                          "rules.bwlimit"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label:
                                                        "Monthly Bandwidth Limit (MB)",
                                                      "data-vv-name": "bwlimit",
                                                      "data-vv-as":
                                                        "Monthly Bandwidth Limit",
                                                      "error-messages": _vm.errors.collect(
                                                        "bwlimit"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.bwlimit,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "bwlimit",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.bwlimit"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: _vm.rules.maxftp,
                                                        expression:
                                                          "rules.maxftp"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label: "Max FTP Accounts",
                                                      "data-vv-name": "maxftp",
                                                      "data-vv-as":
                                                        "Max FTP Accounts",
                                                      "error-messages": _vm.errors.collect(
                                                        "maxftp"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.maxftp,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "maxftp",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "model.maxftp"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: _vm.rules.maxpop,
                                                        expression:
                                                          "rules.maxpop"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label:
                                                        "Max Email Accounts",
                                                      "data-vv-name": "maxpop",
                                                      "data-vv-as":
                                                        "Max Email Accounts",
                                                      "error-messages": _vm.errors.collect(
                                                        "maxpop"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.maxpop,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "maxpop",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "model.maxpop"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: _vm.rules.maxlst,
                                                        expression:
                                                          "rules.maxlst"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label:
                                                        "Max Mailing Lists",
                                                      "data-vv-name": "maxlst",
                                                      "data-vv-as":
                                                        "Max Mailing Lists",
                                                      "error-messages": _vm.errors.collect(
                                                        "maxlst"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.maxlst,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "maxlst",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "model.maxlst"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: _vm.rules.maxsql,
                                                        expression:
                                                          "rules.maxsql"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label:
                                                        "Max SQL Databases",
                                                      "data-vv-name": "maxsql",
                                                      "data-vv-as":
                                                        "Max SQL Databases",
                                                      "error-messages": _vm.errors.collect(
                                                        "maxsql"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.maxsql,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "maxsql",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "model.maxsql"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: _vm.rules.maxsub,
                                                        expression:
                                                          "rules.maxsub"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label: "Max Sub Domains",
                                                      "data-vv-name": "maxsub",
                                                      "data-vv-as":
                                                        "Max Sub Domains",
                                                      "error-messages": _vm.errors.collect(
                                                        "maxsub"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.maxsub,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "maxsub",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "model.maxsub"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          _vm.rules.maxpark,
                                                        expression:
                                                          "rules.maxpark"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label:
                                                        "Max Parked Domains",
                                                      "data-vv-name": "maxpark",
                                                      "data-vv-as":
                                                        "Max Parked Domains",
                                                      "error-messages": _vm.errors.collect(
                                                        "maxpark"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.maxpark,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "maxpark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.maxpark"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          _vm.rules.maxaddon,
                                                        expression:
                                                          "rules.maxaddon"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label:
                                                        "Max Addon Domains",
                                                      "data-vv-name":
                                                        "maxaddon",
                                                      "data-vv-as":
                                                        "Max Addon Domains",
                                                      "error-messages": _vm.errors.collect(
                                                        "maxaddon"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.model.maxaddon,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "maxaddon",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.maxaddon"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          _vm.rules
                                                            .maxpassengerapps,
                                                        expression:
                                                          "rules.maxpassengerapps"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label:
                                                        "Max Passenger Applications",
                                                      "data-vv-name":
                                                        "maxpassengerapps",
                                                      "data-vv-as":
                                                        "Max Passenger Applications",
                                                      "error-messages": _vm.errors.collect(
                                                        "maxpassengerapps"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.model
                                                          .maxpassengerapps,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "maxpassengerapps",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.maxpassengerapps"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("gg-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          _vm.rules
                                                            .max_emailacct_quota,
                                                        expression:
                                                          "rules.max_emailacct_quota"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      label:
                                                        "Max Quota per Email Address (MB)",
                                                      "data-vv-name":
                                                        "max_emailacct_quota",
                                                      "data-vv-as":
                                                        "Max Quota per Email Address",
                                                      "error-messages": _vm.errors.collect(
                                                        "max_emailacct_quota"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.model
                                                          .max_emailacct_quota,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "max_emailacct_quota",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.max_emailacct_quota"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-card",
                            [
                              _c(
                                "gg-card-header",
                                {
                                  attrs: {
                                    divider: _vm.generalSettingsExpanded
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex justify-between"
                                    },
                                    [
                                      _c("div", [_vm._v(" General Settings ")]),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                icon: ""
                                              },
                                              on: {
                                                click: function click($event) {
                                                  _vm.generalSettingsExpanded = !_vm.generalSettingsExpanded
                                                }
                                              }
                                            },
                                            [
                                              _vm.generalSettingsExpanded
                                                ? _c("v-icon", [
                                                    _vm._v("mdi-chevron-down")
                                                  ])
                                                : _c("v-icon", [
                                                    _vm._v("mdi-chevron-right")
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm.generalSettingsExpanded
                                ? _c(
                                    "gg-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "mt-3 px-6"
                                        },
                                        [
                                          _vm.shallAllowed
                                            ? _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("v-checkbox", {
                                                    staticStyle: {
                                                      margin: "0",
                                                      padding: "0"
                                                    },
                                                    attrs: {
                                                      label: "Shell Access"
                                                    },
                                                    model: {
                                                      value: _vm.model.hasshell,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "hasshell",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.hasshell"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0 px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                staticStyle: {
                                                  margin: "0",
                                                  padding: "0"
                                                },
                                                attrs: {
                                                  label: "CGI Access"
                                                },
                                                model: {
                                                  value: _vm.model.cgi,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "cgi",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.cgi"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0 px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c("gg-select", {
                                                attrs: {
                                                  outlined: "",
                                                  label: "cPanel Theme",
                                                  items: _vm.themesOptions
                                                },
                                                model: {
                                                  value: _vm.model.cpmod,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "cpmod",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.cpmod"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0 px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c("gg-select", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: _vm.rules.language,
                                                    expression: "rules.language"
                                                  }
                                                ],
                                                attrs: {
                                                  outlined: "",
                                                  label: "Locale",
                                                  items: _vm.languagesOptions,
                                                  "item-value": "value",
                                                  "item-text": "label",
                                                  "data-vv-name": "language",
                                                  "data-vv-as": "language",
                                                  "error-messages": _vm.errors.collect(
                                                    "language"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.model.language,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "language",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.language"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0 px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                staticStyle: {
                                                  margin: "0",
                                                  padding: "0"
                                                },
                                                attrs: {
                                                  label:
                                                    "Enable Apache SpamAssassin™"
                                                },
                                                model: {
                                                  value: _vm.model.spamassassin,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "spamassassin",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model.spamassassin"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0 px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "flex"
                                                },
                                                [
                                                  _c("v-checkbox", {
                                                    staticStyle: {
                                                      margin: "0",
                                                      padding: "0"
                                                    },
                                                    attrs: {
                                                      disabled: !_vm.model
                                                        .spamassassin
                                                    },
                                                    model: {
                                                      value: _vm.model.spambox,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "spambox",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.spambox"
                                                    }
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "v-label",
                                                      staticStyle: {
                                                        "padding-top": "1px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Enable Spam Box "
                                                      ),
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            bottom: ""
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function fn(
                                                                  _ref
                                                                ) {
                                                                  var on =
                                                                    _ref.on
                                                                  return [
                                                                    _c(
                                                                      "v-icon",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-help-circle"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            2492510221
                                                          )
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c("p", [
                                                              _vm._v(
                                                                "Save spam messages to a folder."
                                                              )
                                                            ]),
                                                            _c("p", [
                                                              _vm._v(
                                                                "When you disable this option, the system delivers messages flagged as spam to the user’s inbox."
                                                              )
                                                            ]),
                                                            _c("p", [
                                                              _vm._v(
                                                                "You must enable Apache SpamAssassin™ to use the Spam Box feature."
                                                              )
                                                            ])
                                                          ])
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-card",
                            [
                              _c(
                                "gg-card-header",
                                {
                                  attrs: {
                                    divider: _vm.mailSettingsExpanded
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex justify-between"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(" Mail Routing Settings ")
                                      ]),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                icon: ""
                                              },
                                              on: {
                                                click: function click($event) {
                                                  _vm.mailSettingsExpanded = !_vm.mailSettingsExpanded
                                                }
                                              }
                                            },
                                            [
                                              _vm.mailSettingsExpanded
                                                ? _c("v-icon", [
                                                    _vm._v("mdi-chevron-down")
                                                  ])
                                                : _c("v-icon", [
                                                    _vm._v("mdi-chevron-right")
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm.mailSettingsExpanded
                                ? _c(
                                    "gg-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "mt-n1 px-6"
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0 px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  staticClass: "py-0 px-0",
                                                  model: {
                                                    value: _vm.model.mxcheck,
                                                    callback: function callback(
                                                      $$v
                                                    ) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "mxcheck",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "model.mxcheck"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.mxcheckOptions,
                                                  function(mxcheck, i) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: i
                                                      },
                                                      [
                                                        _c("v-radio", {
                                                          attrs: {
                                                            value: mxcheck.value
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "label",
                                                                fn: function fn() {
                                                                  return [
                                                                    _c("div", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          mxcheck.label
                                                                        )
                                                                      )
                                                                    ]),
                                                                    mxcheck.showExpanded
                                                                      ? _c(
                                                                          "gg-btn",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "primary",
                                                                              icon:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function click(
                                                                                $event
                                                                              ) {
                                                                                mxcheck.showExpanded = !mxcheck.showExpanded
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-chevron-left"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _c(
                                                                          "gg-btn",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "primary",
                                                                              icon:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function click(
                                                                                $event
                                                                              ) {
                                                                                mxcheck.showExpanded = !mxcheck.showExpanded
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-chevron-right"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                  ]
                                                                },
                                                                proxy: true
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        }),
                                                        mxcheck.showExpanded
                                                          ? _c(
                                                              "v-row",
                                                              _vm._l(
                                                                mxcheck.expand,
                                                                function(
                                                                  subitem,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "v-col",
                                                                    {
                                                                      key: index,
                                                                      staticClass:
                                                                        "pa-0",
                                                                      attrs: {
                                                                        cols:
                                                                          "12"
                                                                      }
                                                                    },
                                                                    [
                                                                      subitem.type ===
                                                                      "list"
                                                                        ? _c(
                                                                            "v-list-item",
                                                                            [
                                                                              subitem.text
                                                                                ? _c(
                                                                                    "v-list-item-content",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-body-2"
                                                                                    },
                                                                                    [
                                                                                      subitem.label
                                                                                        ? _c(
                                                                                            "v-list-item-title",
                                                                                            {
                                                                                              staticClass:
                                                                                                "text-body-1"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    subitem.label
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            subitem.text
                                                                                          ) +
                                                                                          " "
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                : _vm._e()
                                                                            ],
                                                                            1
                                                                          )
                                                                        : subitem.type ===
                                                                          "paragraph"
                                                                        ? _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "text-body-2"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    subitem.text
                                                                                  ) +
                                                                                  " "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "gg-card-header",
                                {
                                  attrs: {
                                    divider: _vm.dnsSettingsExpanded
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex justify-between"
                                    },
                                    [
                                      _c("div", [_vm._v(" DNS Settings ")]),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                icon: ""
                                              },
                                              on: {
                                                click: function click($event) {
                                                  _vm.dnsSettingsExpanded = !_vm.dnsSettingsExpanded
                                                }
                                              }
                                            },
                                            [
                                              _vm.dnsSettingsExpanded
                                                ? _c("v-icon", [
                                                    _vm._v("mdi-chevron-down")
                                                  ])
                                                : _c("v-icon", [
                                                    _vm._v("mdi-chevron-right")
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm.dnsSettingsExpanded
                                ? _c(
                                    "gg-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "mt-3 px-6"
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0 px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _vm.dnsEditingAllowed()
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex"
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        staticStyle: {
                                                          margin: "0",
                                                          padding: "0"
                                                        },
                                                        attrs: {
                                                          disabled: !!_vm.model
                                                            .dmarc
                                                        },
                                                        model: {
                                                          value: _vm.model.dkim,
                                                          callback: function callback(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model,
                                                              "dkim",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.dkim"
                                                        }
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "v-label pt-1"
                                                        },
                                                        [
                                                          _vm._v(" Enable "),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: ""
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function fn(
                                                                      _ref2
                                                                    ) {
                                                                      var on =
                                                                        _ref2.on
                                                                      return [
                                                                        _c(
                                                                          "span",
                                                                          _vm._g(
                                                                            {
                                                                              staticClass:
                                                                                "text-decoration-underline"
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _vm._v(
                                                                              "DKIM"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                3999720940
                                                              )
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "DomainKeys Identified Mail"
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " on this account. "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.dnsEditingAllowed()
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex"
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        staticStyle: {
                                                          margin: "0",
                                                          padding: "0"
                                                        },
                                                        attrs: {
                                                          disabled: !!_vm.model
                                                            .dmarc
                                                        },
                                                        model: {
                                                          value: _vm.model.spf,
                                                          callback: function callback(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model,
                                                              "spf",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.spf"
                                                        }
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "v-label pt-1"
                                                        },
                                                        [
                                                          _vm._v(" Enable "),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: ""
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function fn(
                                                                      _ref3
                                                                    ) {
                                                                      var on =
                                                                        _ref3.on
                                                                      return [
                                                                        _c(
                                                                          "span",
                                                                          _vm._g(
                                                                            {
                                                                              staticClass:
                                                                                "text-decoration-underline"
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _vm._v(
                                                                              "SPF"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                960169410
                                                              )
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Sender Policy Framework"
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " on this account. "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.dnsEditingAllowed()
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex"
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        staticStyle: {
                                                          margin: "0",
                                                          padding: "0"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.dmarc,
                                                          callback: function callback(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model,
                                                              "dmarc",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.dmarc"
                                                        }
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "v-label pt-1"
                                                        },
                                                        [
                                                          _vm._v(" Enable "),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: ""
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function fn(
                                                                      _ref4
                                                                    ) {
                                                                      var on =
                                                                        _ref4.on
                                                                      return [
                                                                        _c(
                                                                          "span",
                                                                          _vm._g(
                                                                            {
                                                                              staticClass:
                                                                                "text-decoration-underline"
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _vm._v(
                                                                              "DMARC"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                1582841662
                                                              )
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Domain-based Message Authentication Reporting and Conformance"
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " on this account. ( "
                                                          ),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: ""
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function fn(
                                                                      _ref5
                                                                    ) {
                                                                      var on =
                                                                        _ref5.on
                                                                      return [
                                                                        _c(
                                                                          "span",
                                                                          _vm._g(
                                                                            {
                                                                              staticClass:
                                                                                "text-decoration-underline"
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _vm._v(
                                                                              "DMARC"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                1582841662
                                                              )
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Domain-based Message Authentication Reporting and Conformance"
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" requires "),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: ""
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function fn(
                                                                      _ref6
                                                                    ) {
                                                                      var on =
                                                                        _ref6.on
                                                                      return [
                                                                        _c(
                                                                          "span",
                                                                          _vm._g(
                                                                            {
                                                                              staticClass:
                                                                                "text-decoration-underline"
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _vm._v(
                                                                              "DKIM"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                3999720940
                                                              )
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "DomainKeys Identified Mail"
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" and "),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: ""
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function fn(
                                                                      _ref7
                                                                    ) {
                                                                      var on =
                                                                        _ref7.on
                                                                      return [
                                                                        _c(
                                                                          "span",
                                                                          _vm._g(
                                                                            {
                                                                              staticClass:
                                                                                "text-decoration-underline"
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _vm._v(
                                                                              "SPF"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                false,
                                                                960169410
                                                              )
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Sender Policy Framework"
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " to be enabled.) "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c("v-checkbox", {
                                                staticStyle: {
                                                  margin: "0",
                                                  padding: "0"
                                                },
                                                attrs: {
                                                  label:
                                                    "Use the nameservers specified at the Domain’s Registrar. (Ignore locally specified nameservers.)"
                                                },
                                                model: {
                                                  value: _vm.model.useregns,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "useregns",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.useregns"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "py-6 px-3",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                type: "submit",
                                loading: _vm.loading,
                                disabled:
                                  _vm.hosting_detail.acct_limit <=
                                  _vm.hosting_detail.acct_used
                              },
                              on: {
                                click: _vm.createSubAccount
                              }
                            },
                            [_vm._v(" Create ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "5"
              }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "gg-card",
                        [
                          _c(
                            "gg-card-header",
                            {
                              attrs: {
                                divider: false
                              }
                            },
                            [_c("div", [_vm._v(" Account Limits ")])]
                          ),
                          _c(
                            "gg-card-text",
                            {
                              staticClass: "px-7"
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "font-bold",
                                  staticStyle: {
                                    "border-bottom": "2px solid #000000"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "6",
                                        sm: "6"
                                      }
                                    },
                                    [_vm._v(" Limit ")]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "6",
                                        sm: "6"
                                      }
                                    },
                                    [_vm._v(" Information ")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticStyle: {
                                    "border-bottom": "1px solid #d7dce4"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "align-self-center",
                                      attrs: {
                                        cols: "3"
                                      }
                                    },
                                    [_vm._v(" Number of Accounts ")]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "align-self-center",
                                      attrs: {
                                        cols: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("v-progress-linear", {
                                            attrs: {
                                              value: _vm.limits.account,
                                              color:
                                                _vm.limits.account < 100
                                                  ? "primary"
                                                  : "error",
                                              height: "15"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "font-bold"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.hosting_detail.acct_used
                                            ) +
                                              " / " +
                                              _vm._s(
                                                _vm.hosting_detail.acct_limit
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c("v-col", {
                                    attrs: {
                                      cols: "6"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticStyle: {
                                    "border-bottom": "1px solid #d7dce4"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "align-self-center",
                                      attrs: {
                                        cols: "3"
                                      }
                                    },
                                    [_vm._v(" Disk Space ")]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "align-self-center",
                                      attrs: {
                                        cols: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("v-progress-linear", {
                                            attrs: {
                                              value: _vm.limits.disk,
                                              color:
                                                _vm.limits.disk < 100
                                                  ? "primary"
                                                  : "error",
                                              height: "15"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "font-bold"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.humanFileSize(_vm.diskUsed)
                                            ) +
                                              " / " +
                                              _vm._s(
                                                _vm.hosting_detail.disk_limit
                                                  ? _vm.humanFileSize(
                                                      _vm.hosting_detail
                                                        .disk_limit
                                                    )
                                                  : "Unlimited"
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "align-self-center",
                                      attrs: {
                                        cols: "6"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Your Disk Usage Limit is calculated based on how much disk space all your accounts have been allocated. "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "align-self-center",
                                      attrs: {
                                        cols: "3"
                                      }
                                    },
                                    [_vm._v(" Bandwidth ")]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "align-self-center",
                                      attrs: {
                                        cols: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("v-progress-linear", {
                                            attrs: {
                                              value: _vm.limits.bw,
                                              color:
                                                _vm.limits.bw < 100
                                                  ? "primary"
                                                  : "error",
                                              height: "15"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "font-bold"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.humanFileSize(
                                                _vm.bandwidthUsed
                                              )
                                            ) +
                                              " / " +
                                              _vm._s(
                                                _vm.hosting_detail.bw_limit
                                                  ? _vm.humanFileSize(
                                                      _vm.hosting_detail
                                                        .bw_limit
                                                    )
                                                  : "Unlimited"
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "align-self-center",
                                      attrs: {
                                        cols: "6"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Your Bandwidth Usage Limit is calculated based on how much bandwidth all your accounts have been allocated. "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }